import { tracking } from '@iwoca/frontend-tracking-library';
import { Icon, Button } from '@iwoca/orion';
import classNames from 'classnames';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { getCountryCode } from '@lendingAPI/lendingAPISelector';
import { isNewOffersEnabled } from '@src/containers/Offers/offers/offersHelpers';
import {
    CHECK_ELIGIBILITY_STEP_ID,
    DEFAULT_STEP_ORDER,
    BUSINESS_INTRODUCTION_STEP_ID,
    PRODUCT_OFFERS_STEP_ID
} from '@src/containers/Routes/helper/stepActiveIds.helper';
import { useNavigateToStep } from '@src/hooks/useNavigateToStep';
import { AppDispatch, RootState } from '@src/reducers';
import { Step } from '@src/reducers/types/reducers.types';
import { getAmplitudeDefaultEventProperties } from '@src/tracking/amplitudeEvents';

import styles from './BackButton.module.css';
import { selectStep } from '../../actions';
import commonMessages from '../../containers/Containers.messages';

const mapStateToProps = (state: RootState) => ({
    lightningLoanConfirmationStep: _.get(
        state,
        'productOffers.lightningLoan.confirmationStep',
        false
    ),
    isNewOffersEnabled: isNewOffersEnabled(state),
    countryCode: getCountryCode(state)
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    selectStep: (selectedStep: Step) => dispatch(selectStep(selectedStep))
});

const BackButton = ({
    lightningLoanConfirmationStep, // TODO: check if this lightningLoanConfirmationStep is needed
    isNewOffersEnabled,
    countryCode,
    selectStep
}: ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>) => {
    const { currentStepId, getPreviousStepId, navigateToStep } =
        useNavigateToStep();

    if (
        countryCode === 'de' &&
        currentStepId === BUSINESS_INTRODUCTION_STEP_ID
    ) {
        return null;
    }

    const goBack = () => {
        tracking.ampli.backCtaClicked({
            'CTA text': commonMessages.back.defaultMessage,
            ...getAmplitudeDefaultEventProperties()
        });

        // TODO: check if this lightningLoanConfirmationStep is needed
        if (lightningLoanConfirmationStep) {
            selectStep({ id: PRODUCT_OFFERS_STEP_ID });
            return navigateToStep(PRODUCT_OFFERS_STEP_ID);
        }

        const previousStepId = getPreviousStepId(
            countryCode === 'de'
                ? DEFAULT_STEP_ORDER.filter(
                      (step) => step !== CHECK_ELIGIBILITY_STEP_ID
                  )
                : DEFAULT_STEP_ORDER,
            isNewOffersEnabled
        );

        if (previousStepId) {
            selectStep({ id: previousStepId });
            return navigateToStep(previousStepId);
        }

        return null;
    };

    return (
        <Button
            className={classNames(styles.backButton, {
                [styles.checkEligibilityBackButton]:
                    currentStepId === CHECK_ELIGIBILITY_STEP_ID
            })}
            data-testid="page-back-button"
            onClick={goBack}>
            <Icon icon="angleLeft" className={styles.backIcon} />
            <FormattedMessage {...commonMessages.back} />
        </Button>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(BackButton);
